import React from 'react';
import cn from 'classnames';

const sizes = {
  default: `py-3 px-8`,
  lg: `py-4 px-12`,
  xl: `py-5 px-16 text-lg`
};

const Button = ({ children, className = '', size, onClick, isSelected, notRounded }) => {
  return (
    <button
      onClick={onClick}
      type="button"
      className={cn(
        sizes[size] || sizes.default,
        'bg-primary',
        'hover:bg-primary-darker',
        !notRounded && 'rounded',
        'text-white',
        className,
        isSelected && 'bg-primary-darker'
      )}
    >
      {children}
    </button>
  );
};

export default Button;
